module.exports = __webpack_public_path__ + "static/media/CARS3.8522cff8.jpg";